// docs/changes/2026-08-19-per-post-date-time-picker.md: the time a deliverable gets when it has never had one.
export const DEFAULT_SCHEDULE_TIME = '09:00'
